import { createStore } from "@tellescope/store";

interface InboxThreadViewStore {
  inboxViewToThreadDataMap: Partial<Record<string, { threadId: string; type: string }>>;
  setInboxViewThreadData: (inboxView: string, threadData?: { threadId: string; type: string }) => void;
}

export const { useStore: useInboxThreadViewStore, useShallowStore: useInboxThreadViewShallowStore } =
  createStore<InboxThreadViewStore>(
    (set) => ({
      inboxViewToThreadDataMap: {},
      setInboxViewThreadData: (inboxView, threadData) => {
        set((state) => ({
          inboxViewToThreadDataMap: {
            ...state.inboxViewToThreadDataMap,
            [inboxView]: threadData,
          },
        }));
      },
    }),
    {
      persist: "sessionStorage",
      name: "INBOX_THREAD_VIEW",
    }
  );
